import { ConfirmedHarmonisedStandardsStep } from '@/v2/components/product-compliance-briefing/ConfirmedHarmonisedStandardsStep'
import type { ConfirmedLvdStandard } from '@/v2/utils/lvdLegislationBriefing'
import type { LvdBriefingStep } from '../../utils/lvdLegislationBriefing'
import { V2LvdLegislationBriefingStepShell } from './V2LvdLegislationBriefingStepShell'

export function V2LvdConfirmedStandardsStep({
  step,
  index,
  standards,
  canWrite,
  onEditStandards,
}: {
  step: LvdBriefingStep
  index: number
  standards: ConfirmedLvdStandard[]
  canWrite: boolean
  onEditStandards: () => void
}) {
  return (
    <ConfirmedHarmonisedStandardsStep
      standards={standards}
      canWrite={canWrite}
      onEditStandards={onEditStandards}
      i18nKeyPrefix='v2.pages.products.detail.lvdBriefing.confirmedStandards'
      stepShell={({ actions, children }) => (
        <V2LvdLegislationBriefingStepShell
          step={step}
          index={index}
          actions={actions}
        >
          {children}
        </V2LvdLegislationBriefingStepShell>
      )}
    />
  )
}
